import type { SyntheticEvent } from "react";
import { selectWhitelistSftpFolderName } from "features/merchants/selectors";
import StatefulSelector from "ui/widgets/StatefulSelector";
import { withUnique } from "./common";
import type { CsvValue, SetupValueProps } from "../types";
import { FormField } from "../../types";

const CsvSftpFolder = ({ values, onChange }: SetupValueProps<CsvValue>) => {
    const onAutocompleteChange = (_: SyntheticEvent, whitelistSftpFolderNames: Array<string>) =>
        onChange!(whitelistSftpFolderNames);

    return (
        <StatefulSelector
            multiple
            fullWidth
            disableClearable
            layout={null}
            sx={{
                gridColumn: 'span 2'
            }}
            selectOptions={selectWhitelistSftpFolderName}
            value={values[FormField.SetupValue].value}
            TextFieldProps={{
                label: 'SFTP Folder',
            }}
            onChange={onAutocompleteChange}
        />
    );
};

export default withUnique(CsvSftpFolder);
